import Icon from '../components/Icon.vue'

Icon.register({"seedling":{"width":512,"height":512,"paths":[{"d":"M64 96H0C0 219.7 100.3 320 224 320V464C224 472.8 231.2 480 240 480H272C280.8 480 288 472.8 288 464V320C288 196.3 187.7 96 64 96zM448 32C363.8 32 290.6 78.5 252.3 147.2 280 177.4 300.5 214.1 311.3 254.8 424 243.1 512 147.9 512 32H448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/seedling.js
// module id = YJoI
// module chunks = 0